module.exports = __webpack_public_path__ + "VIPC1.png?992b91a72bc9005bc325e41915dcba10";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/cycling/VIPC1.png
// module id = 64
// module chunks = 0